import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { SIP } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/SIP" component={SIP} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/SIP/routes.js